import React, { useState } from 'react'; // Added useState
import IconBoxStyle2 from '../../IconBox/IconBoxStyle2';
import SectionHeading from '../../SectionHeading';
import Section from '..';
import Spacing from '../../Spacing'; // Assuming you have this for spacing

export default function DepartmentSectionStyle4({ sectionTitle, sectionTitleUp, data }) {
  // 1. State to track if we show everything or just the first row
  const [showAll, setShowAll] = useState(false);

  // 2. Logic to determine which data to render
  const visibleData = showAll ? data : data?.slice(0, 8);

  return (
    <Section className="cs_gray_bg_1 py-5">
      <div className="container px-lg-5"> 
        <div className="text-center mb-5">
          <SectionHeading title={sectionTitle} titleUp={sectionTitleUp} center />
          <p className="cs_section_desc mx-auto mt-3" style={{ maxWidth: '700px', color: '#64748b', fontSize: '1.1rem' }}>
            Connect with our world-class specialists through a seamless digital experience tailored to your health journey.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {visibleData?.map((item, index) => (
            <div className="col-xl-3 col-lg-4 col-md-6" key={item.id || index}> 
              <IconBoxStyle2 {...item} />
            </div>
          ))}
        </div>

        {/* 3. See More / See Less Button Logic */}
        {data?.length > 8 && (
          <div className="text-center mt-5">
            <button 
              onClick={() => setShowAll(!showAll)} 
              className="cs_btn cs_style_1 cs_type_1" 
              style={{
                background: showAll ? '#f1f5f9' : '#3b82f6',
                color: showAll ? '#c8cfd8' : '#ffffff',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '50px',
                fontWeight: '700',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
            >
              <span>{showAll ? 'Show Less' : 'See More Specialties'}</span>
            </button>
          </div>
        )}
      </div>
    </Section>
  );
}